import { useState } from "react";
import "./CartTabs.css";
import NextCart from "./NextCart";
import Cart from "./Cart";
import { useCart } from "../../context/CartContext";

export default function CartTabs() {
      const {
          nextCart,
          cart,     
      } = useCart();
  
  const [activeTab, setActiveTab] = useState("cart");

  return (
    <div className="cart-tabs-container">
      <div className="cart-tabs">
        <button
          className={`cart-tab-btn ${activeTab === "cart" ? "active" : ""}`}
          onClick={() => setActiveTab("cart")}
        >
          سبد خرید
            <span className="cartLength">
             {cart.length} 
          </span>
         
        </button>

       



        <button
          className={`cart-tab-btn ${activeTab === "saved" ? "active" : ""}`}
          onClick={() => setActiveTab("saved")}
        >
          سبد خرید بعدی
          <span className="cartNextLength">
             {nextCart.length} 
          </span>
        </button>
      </div>

      <div className="cart-tab-content">
        {activeTab === "cart" && (
          <div className="cart-main-tab">
            <Cart />
          </div>
        )}

        {activeTab === "saved" && (
          <div className={nextCart.length > 0 ? "saved-tab" : "saved-tab-full" }>
          {/* <div className="saved-tab"> */}
            <NextCart />

            <div className="saved-info-box">
              <h3>سبد خرید بعدی چیه؟</h3>
              <p>
                اگه چیزی رو می‌خوای بعدا بخری، می‌تونی فعلا این‌جا نگه‌ش داری تا هروقت خواستی به سبد خریدت اضافه کنی.
              </p>
            </div>
          </div>
        )}
      </div>

    </div>
  );
}
